var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1853_7476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.21427 4.28572C2.64594 4.28572 2.1009 4.51149 1.69904 4.91334C1.29718 5.31521 1.07141 5.86025 1.07141 6.42858V26.7857C1.07141 27.354 1.29718 27.8991 1.69904 28.3009C2.1009 28.7027 2.64594 28.9286 3.21427 28.9286H26.7857C27.354 28.9286 27.8991 28.7027 28.3009 28.3009C28.7027 27.8991 28.9286 27.354 28.9286 26.7857V6.42858C28.9286 5.86025 28.7027 5.31521 28.3009 4.91334C27.8991 4.51149 27.354 4.28572 26.7857 4.28572H22.5",
    stroke: "white",
    strokeWidth: 1.92857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.07143V7.5",
    stroke: "white",
    strokeWidth: 1.92857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1.07143V7.5",
    stroke: "white",
    strokeWidth: 1.92857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.28572H18.2143",
    stroke: "white",
    strokeWidth: 1.92857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.64285V17.1429",
    stroke: "white",
    strokeWidth: 1.92857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23.5714C15.5917 23.5714 16.0714 23.0916 16.0714 22.5C16.0714 21.9083 15.5917 21.4286 15 21.4286C14.4083 21.4286 13.9286 21.9083 13.9286 22.5C13.9286 23.0916 14.4083 23.5714 15 23.5714Z",
    stroke: "white",
    strokeWidth: 1.92857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1853_7476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWarning);
export default __webpack_public_path__ + "static/media/calendarWarning.a48b7c9345f5c77f22436e6329c70764.svg";
export { ForwardRef as ReactComponent };